import { useEffect, useRef } from 'react';
import { useSpritesStore } from '../store/spritesSlice';
import { AnimatedSprite } from '@pixi/react';
import { DirectionEnum } from '../types/enums';
import { getSpriteDirectionName } from '../utils/general.utils';

/**
 * The first animation in each dungeon skips its first frame (likely due to load lag).
 * This component forces the textures to render. Temporary workaround pending a real fix.
 */
export const EffectsPreloader = () => {
  const textures = useSpritesStore((s) => s.textures);
  const isLoaded = useSpritesStore((s) => s.isLoaded);
  const hasPreloaded = useRef(false);

  const effectsToPreload = [
    'effects-omnislash',
    'effects-demon-slash',
    'effects-wide-axe',
  ];

  const directions = [
    DirectionEnum.TOP,
    DirectionEnum.BOTTOM,
    DirectionEnum.LEFT,
  ];

  useEffect(() => {
    if (isLoaded && !hasPreloaded.current) {
      hasPreloaded.current = true;
    }
  }, [isLoaded]);

  if (!isLoaded || !hasPreloaded.current) {
    return null;
  }

  return (
    <>
      {effectsToPreload.map((effectName) => {
        const hasDirections = directions.some((dir) => {
          const dirName = getSpriteDirectionName(dir);
          const key = `${effectName}-${dirName}`;
          return textures[effectName]?.animations?.[key] !== undefined;
        });

        if (hasDirections) {
          return directions.map((dir) => {
            const dirName = getSpriteDirectionName(dir);
            const key = `${effectName}-${dirName}`;
            const frames = textures[effectName]?.animations?.[key];

            if (!frames) {
              return null;
            }

            return (
              <AnimatedSprite
                key={key}
                textures={frames}
                initialFrame={0}
                animationSpeed={0.1}
                x={-10000}
                y={-10000}
                visible={true}
                isPlaying={false}
              />
            );
          });
        } else {
          const frames = textures[effectName]?.animations?.[effectName];

          if (!frames) {
            return null;
          }

          return (
            <AnimatedSprite
              key={effectName}
              textures={frames}
              initialFrame={0}
              animationSpeed={0.1}
              x={-10000}
              y={-10000}
              visible={true}
              isPlaying={false}
            />
          );
        }
      })}
    </>
  );
};
